import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Label, Button, CardBody, CardHeader, FormGroup, InputGroup, CardTitle } from 'reactstrap';
import webservice from '../../../Service/webservice';
import * as Yup from 'yup';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from 'formik';
import Select from 'react-select';
import Swal from 'sweetalert2';
import api from '../../../api';


interface FormValues {
  Website: string;
  // Groups: string;
  MobileNo?: string;
  State: string;
  TeamName: string;
  Address: string;
  City: string;
  Currency: string;
  ZipCode: string;
  Country: string;
  FirstName: string,
  LastName: string,
  Position: string,
  Email: string,
  Phone: string,
  Direction: string,
  Password: string,

}



const CountryOptions = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Aland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, Democratic Republic of the' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'Korea (North)' },
  { value: 'KR', label: 'Korea (South)' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia (Federated States of)' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine, State of' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States of America' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];




const fieldMapping: { [key: string]: string } = {
  TeamName: "Company Name",
  Website: "Web site",
  // Groups: "Groups",
  MobileNo: "Mobile No",
  Address: "Address",
  Currency: "Currency",
  ZipCode: "Zip Code",
  State: "State",
  City: "City",
  // Providers: "Providers",
  Country: "Country",
  FirstName: 'First Name',
  LastName: 'Last Name',
  Position: 'Position',
  Email: 'Email',
  Phone: 'Phone',
  Direction: 'Direction',
  Password: 'Password',

};

















const EditTeam: React.FC = () => {
  const navigate = useNavigate();
 const [initialAudit, setInitialAudit] = useState<any>({})
  const [initialValues, setInitialValues] = useState<FormValues>({
    Website: '',
    // Groups: '',
    MobileNo: '',
    TeamName: '',
    State: '',
    Address: '',
    City: '',
    Currency: 'USD',
    ZipCode: '',
    Country: 'US',
    FirstName: '',
    LastName: '',
    Position: '',
    Email: '',
    Phone: '',
    Direction: '',
    Password: '',
    // Providers: [{ firstName: '', middleName: '', lastName: '', providerId: '' }],

  });


  const [refId, setRefId] = useState<string>('');
  const [Id, setId] = useState<string>('');
  const Username = localStorage.getItem('UserName') || '';
 

  // const ProviderSchema = Yup.object().shape({
  //   firstName: Yup.string().required('First Name is required'),
  //   lastName: Yup.string().required('Last Name is required'),
  //   providerId: Yup.string().required('Provider ID is required'),
  // });

  const FORM_VALIDATION = Yup.object().shape({
    TeamName: Yup.string().required("Company Name is required"),
    // Website: Yup.string().required("Website is required"),
    Address: Yup.string().required("Address is required"),
    City: Yup.string().required("City is required"),
    State: Yup.string().required("State is required"),
    ZipCode: Yup.string().required("Zip Code is required"),
    Phone: Yup.string().matches(/^[0-9]+$/, "Phone number must contain only numbers").required("Phone number is required"),

    FirstName: Yup.string().required("First Name is required"),
    // LastName: Yup.string().required("Last Name is required"),
    Email: Yup.string().required("Email is required"),
    // Direction: Yup.string().required("Direction is required"),
    // Password: Yup.string().required("Password is required"),

    // Providers: Yup.array().of(ProviderSchema).required('At least one provider is required').min(1, 'At least one Provider is required'),
  });


  const getUserData = async (id: string) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,id);
    const response = await api.fetch('api/VendorManagement/GetTeamData', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key,response);
  
    return TempData;
  };



  useEffect(() => {
    const fetchData = async () => {
      const data = localStorage.getItem('TeamEdit');
      if (data != null) {
        const res = await getUserData(data);
        if (res.length > 0) {
          setId(res[0].id);
          setRefId(res[0].RefId);
          updateDetails(res);
        }
      }
    };

    fetchData();
  }, []);

  const updateDetails = async (data: any[]) => {
    const Contact_Details = data[0].Contact_Details
    setInitialValues({
      Website: data[0].Website,
      // Groups: data[0].Groups,
      MobileNo: data[0].MobileNo,
      TeamName: data[0].TeamName,
      State: data[0].State,
      Address: data[0].Address,
      City: data[0].City,
      Currency: data[0].Currency,
      ZipCode: data[0].ZipCode,
      Country: data[0].Country,

      FirstName: Contact_Details.FirstName,
      LastName: Contact_Details.LastName,
      Position: Contact_Details.Position,
      Email: Contact_Details.Email,
      Phone: Contact_Details.Phone,
      Direction: Contact_Details.Direction,
      Password: Contact_Details.Password,

      // Providers: data[0].Providers.length > 0 ? data[0].Providers.map((provider: any) => ({
      //   firstName: provider.firstName,
      //   middleName: provider.middleName,
      //   lastName: provider.lastName,
      //   providerId: provider.providerId
      // })) : [{ firstName: '', middleName: '', lastName: '', providerId: '' }],


    });
    setInitialAudit({
      Website: data[0].Website,
      // Groups: data[0].Groups,
      MobileNo: data[0].MobileNo,
      TeamName: data[0].TeamName,
      State: data[0].State,
      Address: data[0].Address,
      City: data[0].City,
      Currency: data[0].Currency,
      ZipCode: data[0].ZipCode,
      Country: data[0].Country,

      FirstName: Contact_Details.FirstName,
      LastName: Contact_Details.LastName,
      Position: Contact_Details.Position,
      Email: Contact_Details.Email,
      Phone: Contact_Details.Phone,
      Direction: Contact_Details.Direction,
      Password: Contact_Details.Password,

      // Providers: data[0].Providers.length > 0 ? data[0].Providers.map((provider: any) => ({
      //   firstName: provider.firstName,
      //   middleName: provider.middleName,
      //   lastName: provider.lastName,
      //   providerId: provider.providerId
      // })) : [{ firstName: '', middleName: '', lastName: '', providerId: '' }],

    });


  };

  const updatedata = async (data: FormValues, id: string) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,{ data, id });
    const res = await api.fetch('api/VendorManagement/edit_team', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then(response => response.json());
    return await AesDecrypt(key,res);
  };

  const updateAuditlog = async (data: any) => {   
    const key = await keyPromise
    data.Userid = localStorage.id;
    data.ParentUserId = localStorage.ParentUserId;
    const EncParams = await AesEncrypt(key,data);

    const response = await api.fetch('api/VendorManagement/EditAuditLogdata', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then(response => response.json());
    return await AesDecrypt(key,response);
  };


  const handleSubmit = async (data: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    // if (isSubmitting) {
    //   return;
    // }
    // setIsSubmitting(true);


    let updatedFields: any[] = [];

    
    for (const key in data) {
      const label = fieldMapping[key] || key;
  
      if (initialAudit && initialAudit[key as keyof FormValues] !== data[key as keyof FormValues]) {
        const beforeValue = initialAudit[key as keyof FormValues];
        const afterValue = data[key as keyof FormValues];
        updatedFields.push({
          field: label,
          before: beforeValue,
          after: afterValue,
        });
      }
    }


    try {
      const ref = await updatedata(data, Id);

      if (ref === 'Username is already taken.') {
        Swal.fire({
          title: 'Warning',
          text: 'Username already exists.',
          icon: 'warning',
          customClass: {},
          showClass: {
            popup: 'animate__animated animate__shakeX',
          },
          buttonsStyling: true,
          allowOutsideClick: false,
        });
      } else if (ref === 'email is already taken.') {
        Swal.fire({
          title: 'Warning',
          text: 'Email already exists.',
          icon: 'warning',
          customClass: {},
          showClass: {
            popup: 'animate__animated animate__shakeX',
          },
          buttonsStyling: true,
          allowOutsideClick: false,
        });
      } else if (ref === 'Username and email are already taken.') {
        Swal.fire({
          title: 'Warning',
          text: 'Username and email already exist.',
          icon: 'warning',
          customClass: {},
          showClass: {
            popup: 'animate__animated animate__shakeX',
          },
          buttonsStyling: true,
          allowOutsideClick: false,
        });
      } else if (ref === 'Edited Successfully') {
        const response = await updateAuditlog({ updatedFields, refId, Username });
        if (response === 'Updated Successfully') {
          Swal.fire({
            title: 'Insurance Verification Platform',
            html: '<span style="color: green;">User Updated successfully!</span>',
            icon: 'success',
            customClass: {},
            showClass: {
              popup: 'animate__animated animate__flipInX',
            },
            buttonsStyling: true,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.value) {
              navigate('/vendormanagement');
            }
          });
        }
      } else {
        throw new Error('Response data is missing or undefined');
      }
    } catch (error) {
      console.error('Error updating Team:', error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'An error occurred while updating the Team.',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      });
    } finally {
      setSubmitting(false);
    }
  };


  const handleNumbers = (event:any) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }

  return (
    <>
      <Breadcrumbs mainTitle='Edit Team' parent='Vendor Management' title='Edit Team' to={`/vendormanagement`} />
      <Fragment>
      <CardBody className='py-2 my-25'>
          <Formik enableReinitialize={true} initialValues={initialValues} validationSchema={FORM_VALIDATION} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
              <Form className="form-horizontal">
                <Card>
                  <CardHeader style={{ backgroundColor: '#B4B4B3' }}>
                    <CardTitle tag="h3">Team Details</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Team Name <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="TeamName" type="text" className="form-control" placeholder="Enter the Team Name" />
                          <ErrorMessage name="TeamName" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      {/* <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Website </Label>
                          <Field name="Website" type="text" className="form-control" placeholder="Enter the Website" />
                          <ErrorMessage name="Website" component="span" className="text-danger" />
                        </FormGroup>
                      </Col> */}
                      {/* <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Groups  <span>   (Mention if it’s a Group of Company)</span></Label>
                          <Field name="Groups" type="text" className="form-control" placeholder="Enter the Groups" />
                          <ErrorMessage name="Groups" component="span" className="text-danger" />
                        </FormGroup>
                      </Col> */}
                      {/* <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check>Currency</Label>
                          <Select
                            name="Currency"
                            options={CurrencyOptions}
                            value={CurrencyOptions.find(option => option.value === values.Currency)}
                            onChange={option => setFieldValue('Currency', option?.value)}
                            className="react-select"
                            classNamePrefix="select"
                          />
                          <ErrorMessage name="Currency" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Mobile No </Label>
                          <Field name="MobileNo" type="text" className="form-control" onInput={handleNumbers} placeholder="Enter the Mobile No." />
                          <ErrorMessage name="MobileNo" component="span" className="text-danger" />
                        </FormGroup>
                      </Col> */}
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Address <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="Address" type="text" className="form-control" placeholder="Enter the Address" />
                          <ErrorMessage name="Address" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> City <span style={{ color: 'red' }}> * </span></Label>
                          <InputGroup>
                            <Field name="City" placeholder="Enter the City" type='text' className="form-control" />
                          </InputGroup>
                          <ErrorMessage name="City" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check>State <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="State" type="text" className="form-control" placeholder="Enter the State" />
                          <ErrorMessage name="State" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check>Zip Code <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="ZipCode" type="text" className="form-control" placeholder="Enter the Zip Code" />
                          <ErrorMessage name="ZipCode" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check>Country</Label>
                          <Select
                            name="Country"
                            options={CountryOptions}
                            value={CountryOptions.find(option => option.value === values.Country)}
                            onChange={option => setFieldValue('Country', option?.value)}
                            className="react-select"
                            classNamePrefix="select"
                          />
                          <ErrorMessage name="Country" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader style={{ backgroundColor: '#B4B4B3' }}>
                    <CardTitle tag="h3">Contact Details</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> First Name <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="FirstName" type="text" className="form-control" placeholder="Enter the First Name" />
                          <ErrorMessage name="FirstName" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Last Name </Label>
                          <Field name="LastName" type="text" className="form-control" placeholder="Enter the Last Name" />
                          {/* <ErrorMessage name="LastName" component="span" className="text-danger" /> */}
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Position </Label>
                          <Field name="Position" type="text" className="form-control" placeholder="Enter the Position" />
                          <ErrorMessage name="Position" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check>Email <span style={{ color: 'red' }}> * </span></Label>
                          <Field name="Email" type="text" className="form-control" placeholder="Enter the Email" />
                          <ErrorMessage name="Email" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Phone <span style={{ color: 'red' }}> * </span></Label>
                          <Field
                            name="Phone"
                            type="text"
                            className="form-control"
                            onInput={handleNumbers}
                            placeholder="Enter the Phone No."
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="16"
                          />
                          <ErrorMessage name="Phone" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      {/* <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Direction <span style={{ color: 'red' }}> * </span></Label>
                          <InputGroup>
                            <Field name="Direction" placeholder="Enter the Direction" type='text' className="form-control" />
                          </InputGroup>
                          <ErrorMessage name="Direction" component="span" className="text-danger" />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <Label check> Password <span style={{ color: 'red' }}> * </span></Label>
                          <InputGroup>
                            <Field name="Password" placeholder="Enter the Password" type={showPassword ? 'text' : 'password'} className="form-control" />
                            <InputGroupText className="cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                              {showPassword ? <EyeOff size={14} /> : <Eye size={14} />}
                            </InputGroupText>
                          </InputGroup>
                          <ErrorMessage name="Password" component="span" className="text-danger" />
                        </FormGroup>
                      </Col> */}
                    </Row>
                  </CardBody>
                </Card>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Link to={`/vendormanagement`}>
                        <Button color="danger" className="me-3">Cancel</Button>
                      </Link>
                      <Button type="submit" color="success" className="me-3">Update</Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Fragment>
    </>
  );
};

export default EditTeam;
